import { Button, Skeleton, HStack, VStack } from '@genial/components';
import React from 'react';

import { PrivatePensionEntityNormalized } from '../../../../../../../../../../store/product/types';
import { PrivatePensionAssetController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/PrivatePension';

import { AccountHolderAndPaymentCard } from './components/AccountHolderAndPaymentCard';
import { BeneficiariesCard } from './components/BeneficiariesCard';
import { PortabilityCard } from './components/PortabilityCard';
import { ProductInfoCard } from './components/ProductInfoCard';

interface PrivatePensionInvestCardProps {
  offer: PrivatePensionEntityNormalized;
  offerController: PrivatePensionAssetController;
  onEditPortability: (index: number) => void;
  onAddPortability: () => void;
  onEditAccountHolder: () => void;
  onEditBeneficiaries: (index: number) => void;
  onAddBeneficiary: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export const PrivatePensionInvestCard: React.FC<PrivatePensionInvestCardProps> = ({
  offer,
  offerController,
  onEditPortability,
  onAddPortability,
  onEditAccountHolder,
  onEditBeneficiaries,
  onAddBeneficiary,
  onCancel,
  onConfirm,
}) => {
  const {
    customerLoading,
    fundLoading,
    insuranceLoading,
    bankAccountsLoading,
    relatedPartyLoading,
    insuranceCompanyParametersLoading,
  } = offerController;

  const isLoading =
    customerLoading ||
    fundLoading ||
    insuranceCompanyParametersLoading ||
    insuranceLoading ||
    bankAccountsLoading ||
    relatedPartyLoading;

  return (
    <VStack width="full" space="stack.xxs">
      <PortabilityCard
        offerController={offerController}
        onEdit={onEditPortability}
        onAdd={onAddPortability}
      />
      <ProductInfoCard offer={offer} offerController={offerController} />
      <AccountHolderAndPaymentCard
        offer={offer}
        offerController={offerController}
        onEdit={onEditAccountHolder}
      />
      <BeneficiariesCard
        offer={offer}
        offerController={offerController}
        onEdit={onEditBeneficiaries}
        onAdd={onAddBeneficiary}
      />
      <HStack width="full" justifyContent="flex-end" space="stack.nano" alignItems="center">
        <Button variant="secondary" onPress={onCancel}>
          Cancelar
        </Button>
        {isLoading ? (
          <Skeleton width="136px" height="48px" borderRadius="full" />
        ) : (
          <Button onPress={onConfirm}>Continuar</Button>
        )}
      </HStack>
    </VStack>
  );
};
